import { io } from 'socket.io-client';
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import Data from 'EurestoClass/Data'
import ApiRequest from 'EurestoApi/ApiRequest'

let project = require('EurestoConfig/project.config')

const listenerSocket = (key, module, donnee) => {
  console.log(key, module, donnee)
  return (data) => {
    console.log(data)
    let notGood = false
    if (data.action !== Constants.broadcastAction.delete) {
      ApiRequest(project.api + data.path, data.params, { showAlertError: false })
        .then(result => {
          switch (data.action) {
            case Constants.broadcastAction.add:
              result.results.map((result) => {
                const d = Data.get(module, donnee, { [Constants.dataObject[key].modifSearch]: result[Constants.dataObject[key].modifSearch] })
                if (!d || !d[Constants.dataObject[key].modifSearch]) {
                  Data.add(module, donnee, result)
                } else {
                  notGood = true
                }
              })
              break
            case Constants.broadcastAction.update:
              result.results.map((result) => {
                Data.update(module, donnee, { [Constants.dataObject[key].modifSearch]: result[Constants.dataObject[key].modifSearch] }, result)
              })
              break
            case Constants.broadcastAction.replace:
              Data.set(module, donnee, result.results)
              break
            default:
              notGood = true
              break
          }
          data.results = result.results
          if (!notGood) {
            Data.restate(module, donnee, data)
          }
        })
    } else {
      Data.rm(module, donnee, { [Constants.dataObject[key].modifSearch]: data.params[Constants.dataObject[key].modifSearch] })
      Data.restate(module, donnee, data)
    }
    /*switch (data.action) {
      case Constants.broadcastAction.add:
        data.results.map((result) => {
          Data.add(module, donnee, result)
        })
        break
      case Constants.broadcastAction.update:
        data.results.map((result) => {
          Data.update(module, donnee, { [Constants.dataObject[key].modifSearch]: result[Constants.dataObject[key].modifSearch] }, result)
        })
        break
      case Constants.broadcastAction.delete:
        Data.rm(module, donnee, { [Constants.dataObject[key].modifSearch]: data[Constants.dataObject[key].modifSearch] })
        break
      case Constants.broadcastAction.replace:
        Data.set(module, donnee, data.results)
        break
      default:
        notGood = true
        break
    }*/
  }
}

const WebSocketDisconnect = _ => {
  socket.disconnect()
  socket.destroy()
}

const isWebSocketConnected = () => socket.connected

const WebSocketContact = (disconnect, id, reconnection = false) => {
  if (socket !== undefined) {
    const contactsConnection = sessionStorage.getItem('websocket_contacts') && JSON.parse(sessionStorage.getItem('websocket_contacts')) || []
    if (reconnection) {
      contactsConnection.map(contact_id => {
        WebSocketContact(false, contact_id)
      })
      return
    } else {
      if (disconnect) {
        const i = contactsConnection.indexOf(id)
        if (i !== -1) {
          contactsConnection.splice(i, 1)
        }
      } else {
        const i = contactsConnection.indexOf(id)
        if (i === -1) {
          contactsConnection.push(id)
        }
      }
      sessionStorage.setItem('websocket_contacts', JSON.stringify(contactsConnection))
    }

    socket.emit('subscribeContact', {
      token: sessionStorage.getItem('token'),
      disconnect: disconnect,
      id: id
    })
    if (!disconnect) {
      socket.off('get').on('get', (data) => {
        User.ContactIdRegisterCallBack.getCbGet().map(cb => {
          cb(data)
        })
      })

      socket.off('dossier').on('dossier', (data) => {
        User.ContactIdRegisterCallBack.getCbDossier().map(cb => {
          cb(data)
        })
      })

      socket.off('action').on('action', (data) => {
        User.ContactIdRegisterCallBack.getCbAction().map(cb => {
          cb(data)
        })
      })

      socket.off('fichier').on('fichier', (data) => {
        User.ContactIdRegisterCallBack.getCbFichier().map(cb => {
          cb(data)
        })
      })
    }
  }
}//true

const suscribeDataWS = () => {
  socket.emit('subscribe', {
    token: sessionStorage.getItem('token'),
  })
}

const connectWS = _ => {
  if (!socket.connected || socket.disconnected)
    socket.connect()
  // console.log(r)
  // suscribeDataWS()
  // WebSocketContact(false, undefined, true)
}

const connect = _ => {
  Object.keys(Constants.dataObject).map((key) => {
    if (Constants.dataObject[key].websocket) {
      const [module, donnee] = key.split('-')
      console.log(key, module, donnee)
      socket.off(key, listenerSocket).on(key, listenerSocket(key, module, donnee))
    }
  })

  socket.onAny((eventName, ...args) => {
    console.log('any', eventName, args)
  });
}

const socket = io(project.api, {
  transports: project.socketTransport,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity
})
  .on('disconnect', reason => {
    console.log(reason)
  })
  .on('error', (error) => {
    console.log('error', error)
  })
  .on('connect', (...args) => {
    suscribeDataWS()
    WebSocketContact(false, undefined, true)
    console.log('I connect to suscribeDataWS, WebSocketContact', args)
  })
  .on('reconnect', (attemptNumber) => {
    console.log('reconnect', attemptNumber)
  })
  .on('destroy', (attemptNumber) => {
    console.log('destroy', attemptNumber)
  })
  .on("connect_error", (...args) => {
    console.log('connect_error', args)
  });
connect()

export {
  connectWS,
  WebSocketContact,
  WebSocketDisconnect,
  isWebSocketConnected
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Websocket/index.js